import { createSelector } from 'reselect';
import { AppState } from '../store';
import { WifiThermostatsState } from '../types/wifiThermostats';

// Helper selectors
const selectWifiThermostatsState = (state: AppState) => (state as any).wifiThermostats as WifiThermostatsState;
const selectItems = (state: WifiThermostatsState) => state.items;
const selectActiveItems = (state: WifiThermostatsState) => state.items;

export const selectWifiThermostats = createSelector(
  selectWifiThermostatsState,
  selectItems,
);

export const selectWifiThermostatsActive = createSelector(
  selectWifiThermostatsState,
  selectActiveItems,
);
